export const DeckType = {
    PASSENGER: 'Passenger',
    BAR: 'Bar',
    DINING: 'Dining',
    UNSPECIFIED: 'Unspecified',
};

export const DeckIndicatorType = {
    BUSINESS_CLASS: 'Business Class',
    BUSINESS_1ERE: 'Business Premiere',
};

export const SeatMapVariant = {
    HORIZONTAL: 'Horizontal',
    VERTICAL: 'Vertical',
};

export const DeckLevelType = {
    UPPER: 'Upper',
    LOWER: 'Lower',
};

export const SeatType = {
    SEAT: 'Seat',
    SHELF: 'Shelf',
    OTHER: 'Other',
    WHEELCHAIR: 'Wheelchair',
    BIKE: 'Bike',
    POLDINGSEAT: 'FoldingSeat',
};

export const StatusType = {
    FREE: 'FREE',
    ALLOCATED: 'ALLOCATED',
    RESTRICTED: 'RESTRICTED',
};

export const Orientation = {
    RIGHT: 'Right',
    LEFT: 'Left',
};

export const ChevronDirection = {
    LEFT: 'left',
    RIGHT: 'right',
};

export const LayoutItemType = {
    LUGGAGERACK: 'LuggageRack',
    LUGGAGEROOM: 'LuggageRoom',
    TABLE: 'Table',
    BATHROOM: 'Bathroom',
    STAIRS: 'Stairs',
    UNKNOWN: 'Unknown',
    OTHER: 'Other',
    EXIT: 'Exit',
};
